import React from 'react';
import MasterLayout from '../AppLayout/MasterLayout/MasterLayout';
import SchoolSelector from './SchoolSelector/SchoolSelector';
import { Box } from '@mui/material';

const SchoolAdmin: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <MasterLayout>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100%' }}>
        <SchoolSelector />
        <Box sx={{ backgroundColor: 'rgb(249, 250, 251)', flex: 1 }}>
          {children}
        </Box>
      </Box>
    </MasterLayout>
  );
};

export default SchoolAdmin;
